import { render, staticRenderFns } from "./MissionExcerpt.vue?vue&type=template&id=2fb60dc6&"
import script from "./missionExcerpt.js?vue&type=script&lang=js&"
export * from "./missionExcerpt.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports